import React from 'react'
import { Container } from './style'

interface PointColors {
  color: string
}
export const Point = ({ color }: PointColors) => {
  return (
    <Container color={color}>
    </Container>
  )
}
